import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-wizard-stepper',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './wizard-stepper.component.html',
  styleUrls: ['./wizard-stepper.component.scss'],
})
export class WizardStepperComponent {
  @Input() currentStep = 1;
  @Input() totalSteps = 1;
  @Input() canGoBack = true;
  @Input() canGoNext = true;
  @Input() canFinish = true;
  @Input() showProgress = true;
  @Input() showActions = true;
  @Input() showFinishOnLastStep = true;

  @Input() backLabelKey = 'Back_tr';
  @Input() nextLabelKey = 'Next_tr';
  @Input() finishLabelKey = 'Accept_tr';

  @Output() back = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() finish = new EventEmitter<void>();

  get progressValue(): number {
    if (!this.totalSteps || this.totalSteps < 1) {
      return 0;
    }
    return Math.max(0, Math.min(100, (this.currentStep / this.totalSteps) * 100));
  }

  get isLastStep(): boolean {
    return this.currentStep >= this.totalSteps;
  }
}
